(function () {
  if (window.__t9Init) return;
  window.__t9Init = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.t9-reveal:not(.t9-visible)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('t9-visible'); }); return; }
    if (!window.__t9io) {
      window.__t9io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('t9-visible'); window.__t9io.unobserve(en.target); } });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (e) { window.__t9io.observe(e); });
  }

  function initHero(root) {
    (root || document).querySelectorAll('.t9-hero').forEach(function (h) {
      if (h.dataset.t9Init) return; h.dataset.t9Init = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return;
      h.addEventListener('pointermove', function (e) {
        var r = h.getBoundingClientRect();
        h.style.setProperty('--t9-x', ((e.clientX - r.left) / r.width * 100) + '%');
        h.style.setProperty('--t9-y', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  function initHotspots(root) {
    (root || document).querySelectorAll('[data-t9-hot]').forEach(function (s) {
      if (s.dataset.t9Init) return; s.dataset.t9Init = '1';
      var puntos = s.querySelectorAll('.t9-punto'), items = s.querySelectorAll('.t9-hot__item');
      function activar(i) {
        puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        items.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
      }
      puntos.forEach(function (p, i) { p.addEventListener('click', function () { activar(i); }); p.addEventListener('mouseenter', function () { activar(i); }); });
      items.forEach(function (p, i) { p.addEventListener('click', function () { activar(i); }); p.addEventListener('mouseenter', function () { activar(i); }); });
      activar(0);
    });
  }

  function initPasos(root) {
    (root || document).querySelectorAll('[data-t9-pasos]').forEach(function (s) {
      if (s.dataset.t9Init) return; s.dataset.t9Init = '1';
      var tabs = s.querySelectorAll('.t9-tab'), fotos = s.querySelectorAll('.t9-pasos__fotos img');
      var dur = parseInt(s.dataset.t9Dur || '6', 10) * 1000, actual = 0, timer = null, visible = false;
      function ir(i) {
        actual = i;
        tabs.forEach(function (t, k) { t.classList.remove('is-activo'); void t.offsetWidth; t.classList.toggle('is-activo', k === i); t.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        fotos.forEach(function (f, k) { f.classList.toggle('is-activo', k === i); });
        clearTimeout(timer);
        if (!reduce && visible && tabs.length > 1) timer = setTimeout(function () { ir((actual + 1) % tabs.length); }, dur);
      }
      tabs.forEach(function (t, i) { t.addEventListener('click', function () { ir(i); }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) ir(actual); else clearTimeout(timer); }, { threshold: 0.3 }).observe(s);
      }
      ir(0);
    });
  }

  function initCalc(root) {
    (root || document).querySelectorAll('[data-t9-calc]').forEach(function (s) {
      if (s.dataset.t9Init) return; s.dataset.t9Init = '1';
      var visitas = s.querySelector('[name=visitas]'), precio = s.querySelector('[name=precio]');
      var oV = s.querySelector('[data-out=visitas]'), oP = s.querySelector('[data-out=precio]');
      var cifra = s.querySelector('[data-out=ahorro]'), coste = parseFloat(s.dataset.coste || '0');
      var mon = s.dataset.moneda || '€';
      function calc() {
        var v = parseFloat(visitas.value), p = parseFloat(precio.value);
        oV.textContent = v; oP.textContent = p + ' ' + mon;
        var ahorro = Math.max(0, Math.round(v * 12 * p - coste));
        cifra.textContent = ahorro.toLocaleString('es-ES') + ' ' + mon;
      }
      visitas.addEventListener('input', calc); precio.addEventListener('input', calc); calc();
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.t9-faq__preg').forEach(function (b) {
      if (b.dataset.t9Init) return; b.dataset.t9Init = '1';
      b.addEventListener('click', function () {
        var item = b.closest('.t9-faq__item'), abierto = item.classList.toggle('is-abierto');
        b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  function initTodo(e) {
    var root = e && e.target && e.target.nodeType === 1 ? e.target : document;
    initReveals(root); initHero(root); initHotspots(root); initPasos(root); initCalc(root); initFaq(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
